<template>
	<b-modal
		ref="modal-specimen-recommended"
		:title="'Recomendaciones'"
		no-close-on-backdrop
		centered
		v-model="isActive"
		@hidden="handleHidden"
		size="xl"
		hide-footer
	>
		<b-overlay :show="isLoading">
			<b-card>
				<b-row class="mb-2">
					<b-col class="d-flex align-items-center" cols="12" md="9">
						<b-tabs v-model="indexTab">
							<b-tab :disabled="false">
								<template #title>Fechas Proximas</template>
							</b-tab>
							<b-tab :disabled="false">
								<template #title>Fechas Pasadas</template>
							</b-tab>
						</b-tabs>
					</b-col>
					<b-col
						class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-xl-end gap-x-2"
						cols="12"
						md="3"
						v-if="indexTab == 1"
					>
						<b-form-checkbox v-model="dateCheck" class="mt-md-1 d-flex align-items-center">
							<span style="white-space: nowrap; font-size: 0.9rem">
								{{ !dateCheck ? "Activar" : "Desactivar" }} filtros
							</span>
						</b-form-checkbox>
						<div class="d-flex align-items-center mt-md-1">
							<feather-icon
								icon="ChevronLeftIcon"
								size="40"
								class="text-primary cursor-pointer"
								:class="{ 'check-disabled': !dateCheck }"
								style="margin-right: 10px"
								@click="previousWeek()"
								:disabled="!dateCheck"
							/>

							<b-form-datepicker
								class="border-primary"
								style="width: 140px"
								locale="en-US"
								placeholder="Desde..."
								:disabled="!dateCheck"
								:date-format-options="{
									month: 'numeric',
									day: 'numeric',
									year: 'numeric',
								}"
								v-model="weekFrom"
							/>
							<b-form-datepicker
								class="border-primary ml-1"
								locale="en-US"
								style="width: 140px"
								placeholder="Hasta..."
								:disabled="!dateCheck"
								:date-format-options="{
									month: 'numeric',
									day: 'numeric',
									year: 'numeric',
								}"
								v-model="weekTo"
							/>

							<feather-icon
								icon="ChevronRightIcon"
								size="40"
								class="text-primary cursor-pointer"
								:class="{ 'check-disabled': !dateCheck }"
								style="margin-left: 10px"
								@click="nextWeek()"
								:disabled="!dateCheck"
							/>
						</div>
					</b-col>
				</b-row>
				<div>
					<RecommendationTable
						:isGeneral="isGeneral"
						:indexTab="indexTab"
						:start="weekFrom"
						:end="weekTo"
						:dateCheck="dateCheck"
					/>
				</div>
			</b-card>
		</b-overlay>
	</b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal"
import ViewImage from "@/components/commons/ViewImage.vue"
import SpecimensRecommendedModal from "@/views/amg/preparacion/components/recommendedSpecimens/SpecimensRecommendedModal.vue"
import TrackingStatusModal from "@/views/amg/preparacion/components/recommendedSpecimens/TrackingStatusModal.vue"
import RecommendationTable from "@/views/amg/preparacion/components/recommendedSpecimens/RecommendationsTable.vue"
import moment from "moment"

export default {
	components: { ViewImage, SpecimensRecommendedModal, TrackingStatusModal, RecommendationTable },
	mixins: [modalMixin],
	props: {
		show: Boolean,
		info: Object,
		isGeneral: Boolean,
	},
	data() {
		return {
			isActive: false,
			isLoading: false,
			title: null,
			indexTab: 0,
			weekFrom: null,
			weekTo: null,
			dateCheck: false,
		}
	},
	async created() {},
	computed: {},
	methods: {
		handleHidden() {
			this.isActive = false
			this.isLoading = false
			this.$emit("closing")
		},
	},
	watch: {
		dateCheck(val) {
			if (!val) {
				this.weekFrom = null
				this.weekTo = null
			}
		},
	},
	async mounted() {
		this.toggleModal("modal-specimen-recommended")
	},
}
</script>

<style scoped>
.check-disabled {
	opacity: 0.5;
	cursor: default;
}
</style>
